var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2937 15.1886C13.0139 20.5463 9.8307 32.426 15.1884 41.7058C20.5461 50.9856 32.4258 54.1687 41.7056 48.811C50.9854 43.4533 54.1686 31.5736 48.8109 22.2938C43.4532 13.014 31.5735 9.83086 22.2937 15.1886ZM39.289 28.9793L37.1574 36.9344C37.0508 37.3322 36.7994 37.6343 36.4799 37.8187C36.1605 38.0031 35.7732 38.0699 35.3754 37.9633C34.6064 37.7572 34.1405 36.9503 34.3466 36.1813L35.5687 31.6203L26.8437 36.6577C26.1544 37.0557 25.2528 36.8141 24.8549 36.1248C24.4569 35.4356 24.6985 34.534 25.3878 34.136L34.1128 29.0986L29.5518 27.8765C28.7828 27.6705 28.3169 26.8635 28.523 26.0945C28.729 25.3255 29.536 24.8597 30.305 25.0657L38.2602 27.1973C39.0292 27.4033 39.495 28.2103 39.289 28.9793Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapArrowIcon);
export default __webpack_public_path__ + "static/media/map-arrow-icon.eaf9a935f2890d256c5e963ac6c9f01a.svg";
export { ForwardRef as ReactComponent };